export default "__VITE_ASSET__DkrCFKPU__"